import { create } from "zustand";

export const useThemeMode = create((set, get) => ({
  mode: 'light',
  setMode: mode => set({ mode }),
}));